import { QuantitySelectorUpdateEvent } from '@theme/events';

/**
 * A compact quantity control for the cart drawer.
 *
 * The stepper it replaces owns the widest slot in a drawer line item to serve a
 * case that barely happens, and that width is what decides whether the price and
 * its saving fit on one line. This dispatches exactly the event the stepper
 * dispatches, so CartItemsComponent keeps handling the update, the removal at
 * zero and the debounce with no change of its own.
 */
class CartQuantitySelect extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#onChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#onChange);
  }

  /**
   * @param {Event} event
   */
  #onChange = (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement)) return;

    const quantity = parseInt(select.value, 10);
    if (Number.isNaN(quantity)) return;

    this.dispatchEvent(new QuantitySelectorUpdateEvent(quantity, Number(select.dataset.cartLine) || undefined));
  };
}

if (!customElements.get('cart-quantity-select')) {
  customElements.define('cart-quantity-select', CartQuantitySelect);
}
